export const AU = () => {
  return (
    <>
      <g clipPath="url(#clip0_1073_11351)">
      <g clipPath="url(#clip1_1073_11351)">
      <rect width="96" height="96" fill="#0066FF"/>
      <circle cx="72" cy="16" r="4" fill="white"/>
      <circle cx="84" cy="32" r="4" fill="white"/>
      <circle cx="64" cy="40" r="4" fill="white"/>
      <circle cx="24" cy="72" r="8" fill="white"/>
      <circle cx="76" cy="72" r="4" fill="white"/>
      <g clipPath="url(#clip2_1073_11351)">
      <rect x="-8.52686" y="48.0416" width="80" height="12" transform="rotate(-45 -8.52686 48.0416)" fill="white"/>
      <rect x="-5.69849" y="50.8701" width="80" height="4" transform="rotate(-45 -5.69849 50.8701)" fill="#EF4444"/>
      <rect x="-0.0415039" y="-8.52686" width="80" height="12" transform="rotate(45 -0.0415039 -8.52686)" fill="white"/>
      <rect x="-2.87012" y="-5.69849" width="80" height="4" transform="rotate(45 -2.87012 -5.69849)" fill="#EF4444"/>
      <rect x="-16" y="16" width="80" height="16" fill="white"/>
      <rect x="16" y="64" width="80" height="16" transform="rotate(-90 16 64)" fill="white"/>
      <rect x="-16" y="20" width="80" height="8" fill="#EF4444"/>
      <rect x="20" y="64" width="80" height="8" transform="rotate(-90 20 64)" fill="#EF4444"/>
      </g>
      </g>
      </g>
      <rect x="2" y="2" width="92" height="92" rx="46" stroke="white" strokeOpacity="0.15" strokeWidth="4"/>
      <defs>
      <clipPath id="clip0_1073_11351">
      <rect width="96" height="96" rx="48" fill="white"/>
      </clipPath>
      <clipPath id="clip1_1073_11351">
      <rect width="96" height="96" rx="24" fill="white"/>
      </clipPath>
      <clipPath id="clip2_1073_11351">
      <rect width="48" height="48" fill="white"/>
      </clipPath>
      </defs>
    </>
  )
}
